
import { Component, Mixins, Vue } from 'vue-property-decorator';
import {
  RadioGroup,
  RadioButton,
  Select,
  Option,
  MessageBox,
} from 'element-ui';
import { Mutation, State } from 'vuex-class';
import BS from '@/views/Home/mixins/bsMixin';
import api from '@/api/course';
import { isExit } from '@/plugin/auth/auth';
import { ISHADECOLOR, IOperateBtn } from '@/types/base.d';
import noAuth from '@/components/noAuth/index.vue';
import Info from './components/info.vue';
import List from './components/list.vue';
import Btn from './components/btn.vue';
import Question from './components/question.vue';
import Asset from './components/asset/index.vue';
import Resource from './components/rescource/index.vue';
import NoChapter from './components/noChapter.vue';
import cModal from './chapter/cModal.vue';
import Homework from './components/Homework/index.vue';
import Video from './components/video/index.vue';
import Knowledge from './components/Knowledge/index.vue';
import Assignment from './components/Assignment/index.vue';
import Exercise from './components/Exercise/index.vue';

@Component({
  components: {
    RadioGroup,
    RadioButton,
    Info,
    List,
    Btn,
    Question,
    Asset,
    NoChapter,
    noAuth,
    cModal,
    Resource,
    Homework,
    Video,
    Knowledge,
    Assignment,
    Exercise,
    Select,
    Option,
    MessageBox,
  },
})
export default class ChapterView extends Mixins(BS) {
  @Mutation('course/SET_COURSE_CHAPTER_CID') setChapterCid!: Function;

  @State((state => state.course.chapter)) chapter!: any;

  private shadeColors: Array<ISHADECOLOR> = [
    {
      way: '45deg',
      colorFirst: '#a1c4fd',
      colorLast: '#7DE2FC',
    },
    {
      way: '45deg',
      colorFirst: '#7DE2FC',
      colorLast: '#a1c4fd',
    },
  ];

  private chapters: any = null;

  private chapterPid: string = '';

  private curChildComp: string = '';

  private curCid: string = '';

  private visible: boolean = false;

  private title: string = '';

  private form: any = {};

  private editType: number = 0; // 默认富文本编辑器，0为富文本，1为markdown

  private btns: Array<IOperateBtn> = [
    {
      title: '资源',
      value: 'Resource',
      icon: 'folder',
      name: '/course/chapter/resource',
      log: {
        name: '课包详情 - 资源',
        component: 'org/operte/components/data',
      },
      callback: () => this.handleBtnClick('Resource'),
    },
    {
      title: '练习题',
      value: 'Question',
      icon: 'inbox',
      name: '/course/chapter/question',
      log: {
        name: '课包详情 - 题库',
        component: 'org/operte/components/form/recharge',
      },
      callback: () => this.handleBtnClick('Question'),
    },
    {
      title: '扩展题',
      value: 'Homework',
      icon: 'inbox',
      name: '/course/chapter/homework',
      log: {
        name: '课包详情 - 题库',
        component: 'org/operte/components/form/recharge',
      },
      callback: () => this.handleBtnClick('Homework'),
    },
    {
      title: '素材',
      value: 'Asset',
      icon: 'photo',
      name: '/course/chapter/asset',
      log: {
        name: '课包详情 - 素材',
        component: 'org/operte/components/form/recharge',
      },
      callback: () => this.handleBtnClick('Asset'),
    },
    {
      title: '视频',
      value: 'Video',
      icon: 'video-camera',
      name: '/course/chapter/video',
      log: {
        name: '课包详情 - 视频',
        component: 'org/operte/components/data',
      },
      callback: () => this.handleBtnClick('Video'),
    },
    // {
    //   title: '拓展',
    //   value: '',
    //   icon: 'truck',
    //   name: '/course/chapter:expand',
    //   log: {
    //     name: '课包详情 - 拓展',
    //     component: 'org/operte/components/form/contract',
    //   },
    //   callback: () => this.handleBtnClick(''),
    // },
    {
      title: '知识点',
      value: 'Knowledge',
      icon: 'file-text-o',
      name: '/course/chapter/knowledge',
      log: {
        name: '课包详情 - 知识点',
        component: 'org/operte/components/data',
      },
      callback: () => this.handleBtnClick('Knowledge'),
    },
    {
      title: '课后作业',
      value: 'Assignment',
      icon: 'edit',
      name: '/course/chapter/assignment',
      log: {
        name: '课包详情 - 课后作业',
        component: '/course/chapter/assignment',
      },
      callback: () => this.handleBtnClick('Assignment'),
    },
    {
      title: '随堂练习',
      value: 'Exercise',
      icon: 'edit',
      name: '/course/chapter/exercise',
      log: {
        name: '课包详情 - 随堂练习',
        component: '/course/chapter/exercise',
      },
      callback: () => this.handleBtnClick('Exercise'),
    },
  ];

  private loading: boolean = true;

  public $refs!: {
    btns: HTMLElement,
    comp: any,
  };

  mounted() {
    this.curChildComp = this.compCurComp();
    if (this.$route.params.cid) this.setChapterCid(this.$route.params.cid);
    else this.setChapterCid('');
    this.getData();
    this.initBS(this.$refs.btns, {
      scrollY: false,
      scrollX: true,
      scrollbar: false,
    });
  }

  compCurComp(): string {
    /* eslint-disable no-else-return */
    const authBtn: Array<IOperateBtn> = this.btns.filter((btn: IOperateBtn) => isExit(btn.name));
    const type: string = this.$route.params.type || '';
    if (!type) return authBtn.length > 0 ? authBtn[0].value || '' : 'noAuth';
    else if (authBtn.filter((btn: IOperateBtn) => btn.value === type).length > 0) return type;
    return 'noAuth';
  }

  handleBtnClick(comp: string) {
    this.curChildComp = comp;
    this.$nextTick(() => {
      this.getChildCompData(this.chapter.cid);
    });
  }

  // handleSelectChange(v: string) {
  //   this.handleBtnClick(v);
  // }

  /**
   * @author Terry
   * @description 处理点击章节事件
   */
  handleClickItem(pid: string, index: number) {
    this.setChapterCid(pid);
    this.getChildCompData(this.chapter.cid);
  }

  getChildCompData(pid: string) {
    if (this.curChildComp === 'noAuth') {
      this.loading = false;
      return;
    }
    this.loading = true;
    this.$nextTick(() => {
      this.$refs.comp.getData(pid).then((res: any) => {
        if (res && res.length >= 0) this.loading = false;
      });
    });
  }

  /**
   * @author Terry
   * @desc 获取课程章节
   */
  getData(flag: boolean = false) {
    api.getChapter(Base64.decode(this.$route.params.pid)).then((res: any) => {
      this.chapters = res;
      if (this.chapters.length > 0) {
        // console.log(this.chapters[0].pid);
        // console.log(this.setChapterCid(this.chapters[0].pid));
        /* eslint-disable no-unused-expressions */
        this.chapter.cid ? '' : this.setChapterCid(this.chapters[0].pid);
        this.curChildComp = 'Resource';
        if (!flag) this.getChildCompData(this.chapter.cid);
      } else {
        this.loading = false;
        this.curChildComp = 'NoChapter';
      }
    });
  }

  handleAdd() {
    this.visible = true;
    this.title = '添加章节';
  }

  handleEdit(pid: string) {
    api.getAsset(pid).then((res) => {
      this.form = res;
      this.visible = true;
      this.title = '修改章节';
    });
  }

  private isHTML(str: string): boolean {
    // 检查常见的HTML标签
    const commonTags = /<(div|p|span|a|img|table|ul|ol|li|h[1-6]|br|hr|input|button|form|script|link|meta)[\s>]/i;

    // 检查HTML实体
    const htmlEntities = /&[a-z]+;|&#\d+;/i;

    // 检查是否包含完整的HTML标签结构
    const completeTag = /<[a-z][\s\S]*?>[\s\S]*?<\/[a-z][\s\S]*?>/i;

    return commonTags.test(str) || htmlEntities.test(str) || completeTag.test(str);
  }

  private isMarkdown(str: string): boolean {
    const markdownRegex = /(?:^|\n)(?:[#*`>]|\d+\.|[-*+]\s)/m;
    return markdownRegex.test(str);
  }

  handleEditContent(pid: string, editType) {
    api.getChapterContent(pid).then((res) => {
      this.form = res;
      if (editType === 1) {
        this.editType = editType;
        this.visible = true;
        this.title = '修改章节内容';
      } else if (editType === 0 && this.isHTML(res.stepPoints)) {
        MessageBox.confirm('该课程内容为富文本格式，您是否要切换到 Markdown 编辑器进行编辑？', '提示', {
          confirmButtonText: '使用 Markdown',
          cancelButtonText: '继续使用富文本',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          customClass: 'my-custom-message-box',
        }).then(() => {
          this.editType = 2;
          this.visible = true;
          this.title = '修改章节内容';
        }).catch(() => {
          this.editType = 0;
          this.visible = true;
          this.title = '修改章节内容';
        });
      } else {
        this.title = '修改章节内容';
        this.editType = 2;
        this.visible = true;
      }
    });
  }

  handleDelete(pid: string) {
    this.confirm('你确定要删除该课程吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeChapter(pid).then(() => {
        this.setChapterCid('');
        this.getData();
        close();
        this.$log({
          title: '课程章节 - 删除 - 确定',
          component: 'course/chapter',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '课程章节 - 删除 - 取消',
      component: 'course/chapter',
    }));
  }
}
